<template>
	<div class="empty-state">
		<div class="empty-state--icon"></div>
		<div class="f-16 f-bold">{{ message }}</div>
		<div class="f-14 f-c-midgrey">{{ subMessage }}</div>
    <div v-if="btnAction">
      <SOButton
        :outline="true"
        :text="btnText"
        :id="`btn-on-empty-state`"
        @action="doAction"
      />
    </div>
	</div>
</template>

<script>
import SOButton from "@/so-components/global/ui/SOButton";

export default {
	name: "SOEmptyState",
  components: {
    SOButton,
  },
	props: {
    message : {
      type: String
    },
    subMessage : {
      type: String
    },
    btnAction : {
      type: Boolean,
      default: false,
    },
    btnText : {
      type: String,
      default: "Salin Link Referall"
    }
  },
  methods: {
    doAction(payload) {
      this.$emit("action", payload)
    }
	}
}
</script>